module.exports = __webpack_public_path__ + "static/media/app-screen-03.18e395d5.jpg";